module.exports = __webpack_public_path__ + "static/campbell-page-00-hero-37adfb5234cb6b9f9717cbf46c186154.jpg";